import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1261.96322,920.139786 L1141.3022,1040.80081 L960.481253,859.866138 L779.546585,1040.80081 L658.885565,920.139786 L839.820233,739.205118 L658.885565,558.27045 L779.546585,437.723153 L960.481253,618.657821 L1141.3022,437.723153 L1261.96322,558.27045 L1081.02855,739.205118 L1261.96322,920.139786 Z M1415.37671,0 L505.585796,0 C411.422437,0 335,76.5361606 335,170.585796 L335,1920 L960.481253,1544.71125 L1585.96251,1920 L1585.96251,170.585796 C1585.96251,76.5361606 1509.42635,0 1415.37671,0 L1415.37671,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRemoveBookmarkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRemoveBookmarkSolid, _Component);

  var _super = _createSuper(IconRemoveBookmarkSolid);

  function IconRemoveBookmarkSolid() {
    _classCallCheck(this, IconRemoveBookmarkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRemoveBookmarkSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRemoveBookmark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRemoveBookmarkSolid.displayName = "IconRemoveBookmarkSolid";
  return IconRemoveBookmarkSolid;
}(Component);

IconRemoveBookmarkSolid.glyphName = 'remove-bookmark';
IconRemoveBookmarkSolid.variant = 'Solid';
IconRemoveBookmarkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRemoveBookmarkSolid;
export { IconRemoveBookmarkSolid };